export class EnderecoResidencial {

    public bairro: string;
    public cep: string;
    public cidade: string;
    public logradouro: string;
    public numero: number;
    public uf: string;
    public complemento: string;

    constructor(endereco: any) {
        if (endereco === undefined) {
            endereco = {
                bairro: undefined,
                cep: undefined,
                cidade: undefined,
                logradouro: undefined,
                numero: undefined,
                uf: undefined,
                complemento: undefined
            };
        }

        this.bairro = endereco.bairro;
        this.cep = endereco.cep;
        this.cidade = endereco.cidade;
        this.logradouro = endereco.logradouro;
        this.numero = endereco.numero;
        this.uf = endereco.uf;
        this.complemento = endereco.complemento;

    }
}



// WEBPACK FOOTER //
// ./src/app/resources/classes/enderecoDeprecated.ts